import { NgModule } from '@angular/core';
import { AuroraTextComponent } from './aurora-text.component';

@NgModule({
    declarations: [
        AuroraTextComponent
    ],
    imports: [],
    exports: [
        AuroraTextComponent
    ]
})
export class NcAuroraTextModule { }